/* unplugin-vue-components disabled */import script from "./ColorPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorPicker.vue?vue&type=script&setup=true&lang=ts"

import "./ColorPicker.vue?vue&type=style&index=0&id=00822044&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00822044"]])

export default __exports__